import React from 'react';


export default function Navbar(props) {
  return (

    <nav style={{ backgroundColor: props.mode === 'dark' ? '#D5DADB' : '#839BA2' }} className={'navbar navbar-expand-lg '}>
      <div className="container-fluid">
        <a className="navbar-brand " href="#">Free Text Formatter</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarText">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link " aria-current="page" href="#">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">About</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">Contact</a>
            </li>
          </ul>


          <div className={'form-check form-switch text-${props.mode === light? dark:light}'}>
            <input className="form-check-input" onClick={props.togglemode} type="checkbox" role="switch" id="flexSwitchCheckDefault" />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">DarkMode</label>
          </div>
        </div>
      </div>
    </nav>
  )
}